store.admin.filters = {};
store.admin.filters.init = function() {

	var $filters = $('#filters');
	var $table = $filters.find('table');
	// nestedSortble has a very nice css for .handle
	$table.addClass('nestedSortable');
	$table.find('th').each(function(){
		var $t = $(this);
		// Set width so we dont mess up the column widths when dragging a tr
		$t.css('width', $t.width()+"px");
	});
	var $tbody = $table.find('tbody');
	$tbody.addClass('ui-sortable');
	$tbody.sortable({
		handle: '.handle'
	});
};
